import * as S from './styles'
import { Button } from 'base/src/components/Button'
import { RootStateCarteira } from '../../../../store/carteiraReducer';
import { connectUtil, PropsFromRedux } from 'base/src/utils/reduxUtil';
import { formatToBRL } from 'base/src/utils/mathUtil';
import StateMensage from 'base/src/view/states/state';
import { CARTEIRA_BASE_GET } from 'domain/types/_carteira/carteiraBase/carteiraBase';
import { useState } from 'react';
import { Icon } from '@iconify/react';
import { Tooltip, TooltipContent, TooltipTrigger } from 'base/src/components/Tooltip';
import TransferenciaModal from '../TransferenciaModal';

const connector = connectUtil(
  (state: RootStateCarteira) => ({
    homeInfo: state.CarteiraBaseReducer.CarteiraBase,
    CarteiraUsuario: state.CarteiraBaseReducer.CarteiraUsuario,
  }),
  {  }
);

export interface CarteiraHomeComponentProps extends PropsFromRedux<typeof connector> {
}

function PrimaryCard (props: CarteiraHomeComponentProps) {
  const [isTransferenciaModalOpen, setIsTransferenciaModalOpen] = useState(false);

  function handleTransferenciaClick() {
    setIsTransferenciaModalOpen(true)
  }

  return (
    <S.Container>
      {
        props.homeInfo !== null &&
        <>
          <S.TextContainer>
            <S.ContainerSubtitle>
              <S.Title>Saldo Atual</S.Title>
              <S.Value>{props.homeInfo.EsconderSaldo ? "R$ *****,**" : formatToBRL(props.homeInfo.BalancoAtual || 0)}</S.Value>
            </S.ContainerSubtitle>

            {/* <S.ContainerSubtitle>
              <S.Subtitle>Saldo Pendente</S.Subtitle>
              <S.SecondaryValue>{formatToBRL(props.homeInfo.BalancoPendente || 0)}</S.SecondaryValue>
            </S.ContainerSubtitle> */}
            
          <S.ContainerSubtitle>
            <S.Subtitle>Saldo em Processamento</S.Subtitle>
            <S.SecondaryValue>{props.homeInfo.EsconderSaldo ? "R$ *****,**" : formatToBRL(props.homeInfo.SaldoBloqueado || 0)}</S.SecondaryValue>
          </S.ContainerSubtitle>

          </S.TextContainer>
          <S.ButtonWrapper>
            <Tooltip>
              <TooltipTrigger asChild>
                <S.StyledLink to='/deposito' style={{}}>
                  <Button
                    size='md'
                    variant='coopercred'
                  >
                    <Icon icon="mingcute:arrow-down-circle-line" width={18}/>
                  </Button>
                </S.StyledLink>
              </TooltipTrigger>
              <TooltipContent>
                Depositar - Adicionar dinheiro à sua carteira digital
              </TooltipContent>
            </Tooltip>
            
            <Tooltip>
              <TooltipTrigger asChild>
                <Button
                  size='md'
                  variant='danger'
                  onClick={handleTransferenciaClick}
                >
                  <Icon icon="mingcute:arrow-up-circle-line" width={18}   />
                </Button>
              </TooltipTrigger>
              <TooltipContent>
                Resgatar - Transferir dinheiro via PIX para outra conta
              </TooltipContent>
            </Tooltip>
          </S.ButtonWrapper>
          <StateMensage stateLoadingNames={[CARTEIRA_BASE_GET]} stateErrorNames={[CARTEIRA_BASE_GET]} />
        </>
      }
      
      <TransferenciaModal 
        isOpen={isTransferenciaModalOpen}
        onOpenChange={setIsTransferenciaModalOpen}
        homeInfo={props.homeInfo}
        CarteiraUsuario={props.CarteiraUsuario}
      />
    </S.Container>
  )
}

export default connector(PrimaryCard);